import { localStorageObjectStore } from './localStorageStore';
function createUserExerciseData(id) {
    return { id: id, completed: false, code: "" };
}
const initialData = {};
const userExerciseDataStore = localStorageObjectStore('userExerciseDataStore', initialData);
export { userExerciseDataStore, createUserExerciseData };
